import type { PresencePeer, SessionUser } from '../types';

export type SyncState = 'live' | 'syncing' | 'offline';

interface Props {
  state: SyncState;
  statusMsg: string;
  me: SessionUser;
  peers: PresencePeer[];
}

export default function SyncBanner({ state, statusMsg, me, peers }: Props) {
  return (
    <div className="sync-banner">
      <div className="sb-left">
        <div
          className={
            'sb-dot' +
            (state === 'syncing' ? ' syncing' : '') +
            (state === 'offline' ? ' offline' : '')
          }
        />
        <span className="sb-status">{statusMsg}</span>
        <div className="live-editors">
          {peers.map((p) => (
            <div
              key={p.user_id}
              className="live-avatar"
              style={{ background: p.color }}
              title={p.display_name}
            >
              {(p.display_name[0] ?? '?').toUpperCase()}
            </div>
          ))}
        </div>
      </div>
      <div className="sb-right">
        <div className="user-badge">
          <div
            className="user-avatar"
            style={{ background: me.color }}
            aria-hidden="true"
          >
            {(me.display_name[0] ?? '?').toUpperCase()}
          </div>
          <span>{me.display_name}</span>
        </div>
      </div>
    </div>
  );
}
